<template>
  <v-container class="ma-0 pa-0" v-if="config != null">
    <h3 class="text-left">
      {{ $t("actions.config.mqttTitleConfigDescription") }}
    </h3>

    <broker-selector v-model="config.brokerId" />
    <v-text-field
      :label="$t('actions.config.mqttTopicTemplate')"
      name="topicTemplate"
      type="text"
      v-model="config.topicTemplate"
      hide-details
      mb-0
    />
    <h5 class="text-left">
      {{ $t("actions.config.mqttTopicTemplateConfigDescription") }}
      <p class="font-weight-thin">
        {{ $t("actions.config.availableTitleVariables") }}
        {{ $t("actions.config.variables." + eventType) }}
      </p>
    </h5>
  </v-container>
</template>

<script>
import BrokerSelector from "@/components/mqtt/BrokerSelector";

const mqttConfigDefault = {
  brokerId: null,
  topicTemplate: "sensoronline/action/event/{id}",
  retain: false,
};

export default {
  name: "ActionMqttConfigForm",

  components: {
    BrokerSelector,
  },

  props: {
    value: {
      type: String,
      default: JSON.stringify(mqttConfigDefault),
    },

    eventType: {
      type: Number,
      required: true,
    },
  },

  model: {
    prop: "value",
    event: "input",
  },

  data() {
    return { config: mqttConfigDefault };
  },

  methods: {
    setLocalConfig() {
      try {
        this.config = JSON.parse(this.value);
        if (!this.config?.brokerId) {
          this.config = mqttConfigDefault;
        }
      } catch {
        this.config = mqttConfigDefault;
      }
    },
  },

  watch: {
    value(val) {
      this.config = JSON.parse(val);
      this.setLocalConfig();
    },

    config: {
      handler(val) {
        this.$emit("input", JSON.stringify(val));
      },
      deep: true,
    },
  },

  created() {
    this.setLocalConfig();
  },
};
</script>
